import React, { useState, useEffect } from "react";
import LeftMenu01 from "../../../components/layout/leftMenu01.jsx";
import Header from "../../../components/layout/header-candidate.jsx";
import { useNavigate } from 'react-router-dom';
import { backendApi } from "../../../api/apiService.js";
import { useSelector } from "react-redux";
import LOading from "../../../images/loadin_gif.gif";

function AssessmentHomePage() {
    const [menuClick, setMenuClick] = useState(false);
    const navigate = useNavigate();
    const [appliedList, setAppliedList] = useState([]);
    const [Loader, setLoader] = useState(false);

    const { candidateId } = useSelector((state) => state.login);

    const GetData = () => {
        const req = {
            functionName: "candidateQuestionnaireListing",
            candidate_id: candidateId
        };
        backendApi(req)
            .then((response) => {
                if (response.success === "1") {
                    console.log(response.dataSet, "response.dataSet");
                    setAppliedList(response.dataSet)
                    setLoader(true);
                }
            })
            .catch((err) => {
                console.log("error", err);
            });
    };
    const toggleMenu = () => {
        setMenuClick(!menuClick)
    }
    const closeMenu = () => {
        setMenuClick(false)
    }
    useEffect(() => {
        setTimeout(() => {
            document.getElementById("assessmentMenu").classList.add("active");
        }, 500);
        GetData();
    }, []);
    const handleClick = (item) => {
        console.log(item, "item");
        navigate('/candidate-assessment', { state: { Data: item } });
    };
    const getStatusStyle = (status) => {
        switch (status) {
            case 'Open':
                return { color: 'green' };
            case 'Submited':
                return { color: 'red' };
            default:
                return { color: 'black' };
        }
    };

    return (
        <div className="main-wrapper">
            <div className="top-color"></div>
            <LeftMenu01 menuClick={menuClick} closeMenu={closeMenu} />
            <div className="content-wrapper">
                <Header Header="Candidate Assessment" toggleMenu={toggleMenu} menuClick={menuClick} />
                <div className="main-container">
                    <div className="row mb-3">
                        <div className="col-lg-12 col-md-12">
                            <div className="card main-card-box">
                                <div className="card-body">
                                    <div className="row">
                                        <div class="table-responsive">
                                            {!Loader ? (
                                                <div className="form-container">
                                                    <img src={LOading} alt="Loading"></img>
                                                </div>
                                            ) : (
                                                <table class="table">
                                                    <thead>
                                                        <tr>
                                                            <th>Company Name</th>
                                                            <th>Schedule Date & Time</th>
                                                            <th>Time per Question</th>
                                                            <th>Total Questions</th>
                                                            <th>Status</th>

                                                            <th></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {appliedList.length === 0 ? (
                                                            <tr>
                                                                <td colSpan="6" style={{ textAlign: 'center', color: "red" }}>No Data Available</td>
                                                            </tr>
                                                        ) : (
                                                            appliedList.map((item) => (
                                                                <tr key={item.candidate_questionnaire_id}>
                                                                    <td>{item.company_name}</td>
                                                                    <td>{new Date(item.schedule_date_time * 1000).toLocaleString()}</td>
                                                                    <td>{item.exam_time} Sec</td>
                                                                    <td>{item.total_question}</td>
                                                                    <td style={getStatusStyle(item.exam_status)}>
                                                                        {item.exam_status}
                                                                    </td>
                                                                    <td>
                                                                        {item.exam_status === 'Open' && (
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-primary btn-sm"
                                                                                style={{ fontSize: "14px" }}
                                                                                onClick={() => handleClick(item)}
                                                                            >
                                                                                Start
                                                                            </button>
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        )}
                                                    </tbody>

                                                </table>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AssessmentHomePage